import Button, {
  ButtonSize,
  ButtonVariant,
} from '@/components/BaseLibrary/Button/Button';
import FeaturedArticle from '@/components/BlogComponents/BlogCategorySplit/FeaturedArticle/FeaturedArticle';
import BlogCuratedArticleList from '@/components/BlogComponents/BlogCuratedArticleList/BlogCuratedArticleList';
import { IconName } from '@/components/Icon/Icon';
import type { BlogPageType } from '@/contentful/api/api.types';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './SplitSection.styles';

type SplitSectionProps = {
  heading?: string;
  image?: string;
  featuredArticle: BlogPageType;
  additionalArticles: BlogPageType[];
  onClick: () => void;
};

const SplitSection = ({
  heading,
  featuredArticle,
  additionalArticles,
  onClick,
}: SplitSectionProps) => {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles();

  return (
    <div className={classes.wrapper}>
      {heading && (
        <h2 className={cx(globalClasses.h2, classes.title)}>{heading}</h2>
      )}
      <FeaturedArticle article={featuredArticle} />
      <BlogCuratedArticleList articles={additionalArticles} />
      <Button
        variant={ButtonVariant.SECONDARY}
        onClick={onClick}
        label='See more'
        className={cx(
          additionalArticles.length === 0 && classes.buttonSpacing,
          classes.buttonOverride
        )}
        iconName={IconName.ARROW_RIGHT}
        size={{ xs: ButtonSize.SM, md: ButtonSize.MD }}
      />
    </div>
  );
};

export default SplitSection;
